import axios from 'axios'
const FormApi = window.env.VUE_APP_FORM_OPEN

function getAxios() {
    if (window.env.NODE_ENV === 'development') {
        return axios.create({
            baseURL: '/api'
        })
    } else {
        return axios.create({
            baseURL: window.env.VUE_APP_API
        })
    }
}
const axiosInstance = getAxios()
axiosInstance.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        return Promise.reject(error)
    }
)
export { FormApi, axiosInstance as axios }
